import type { gender, nationality, salutation, profession } from '../../types';
import { ContextAction } from '../../types';
export type ConfigState = {
  gender: gender[];
  nationalities: nationality[];
  salutations: salutation[];
  profession: profession[];
};

export const configInitial = {
  gender: [],
  nationalities: [],
  salutations: [],
  profession: []
};

export type ConfigAction =
  | {
      type: ContextAction.setGenderConfig;
      payload: gender[];
    }
  | {
      type: ContextAction.setNationalityConfig;
      payload: nationality[];
    }
  | {
      type: ContextAction.setSalutationonfig;
      payload: salutation[];
    }
  | {
      type: ContextAction.setProfessionConfig;
      payload: profession[];
    };

export const configReducer = (
  state: ConfigState,
  action: ConfigAction
): ConfigState => {
  switch (action.type) {
    case ContextAction.setGenderConfig:
      return { ...state, gender: action.payload };
    case ContextAction.setNationalityConfig:
      return { ...state, nationalities: action.payload };
    case ContextAction.setSalutationonfig:
      return { ...state, salutations: action.payload };
    case ContextAction.setProfessionConfig:
      return { ...state, profession: action.payload };
    default:
      return state;
  }
};
